import { render, staticRenderFns } from "./documentmodale.vue?vue&type=template&id=627a32fc&scoped=true"
import script from "./documentmodale.vue?vue&type=script&lang=js"
export * from "./documentmodale.vue?vue&type=script&lang=js"
import style0 from "./documentmodale.vue?vue&type=style&index=0&id=627a32fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "627a32fc",
  null
  
)

export default component.exports